import _isFunction from "lodash/isFunction";
import React, { useMemo, useRef } from 'react';
import styled from 'styled-components';
import { baseDialogStyles } from "../Dialog/Dialog";
import { Collapse, CollapseContent, CollapseTrigger } from "../Collapse";
import { motion } from 'framer-motion';
import { eases } from "../../motion/eases";
import { useAccordionDialogContext } from "./useAccordionDialog";
import { TRANSITION } from "./animation-constants";
import { Text } from "../Text";
import { useDialogContext } from "../Dialog";
import { buttonReset } from "../Button";
import { theme, whenFocused } from "../../theme";
export function AccordionDialogItem(_ref) {
  var adornmentBefore = _ref.adornmentBefore,
      adornmentAfter = _ref.adornmentAfter,
      title = _ref.title,
      idProp = _ref.id,
      children = _ref.children;

  var _useDialogContext = useDialogContext(),
      id = _useDialogContext.id;

  var ref = useRef(null);

  var _useAccordionDialogCo = useAccordionDialogContext(ref, idProp),
      onChange = _useAccordionDialogCo.onChange,
      size = _useAccordionDialogCo.size,
      expanded = _useAccordionDialogCo.expanded,
      index = _useAccordionDialogCo.index;

  var header = useMemo(function () {
    return /*#__PURE__*/React.createElement(HeaderContainer, null, _isFunction(adornmentBefore) ? adornmentBefore(expanded) : adornmentBefore, /*#__PURE__*/React.createElement(Text, {
      id: index === 0 ? id : undefined,
      variant: "primary",
      color: "primary"
    }, title), _isFunction(adornmentAfter) ? adornmentAfter(expanded) : /*#__PURE__*/React.createElement(AnimatedCallToAction, {
      "aria-hidden": expanded,
      animate: {
        opacity: expanded ? 0 : 1
      },
      transition: TRANSITION
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "body",
      color: "primary"
    }, adornmentAfter)));
  }, [adornmentAfter, adornmentBefore, expanded, id, index, title]);
  return /*#__PURE__*/React.createElement(AnimatedMountContainer, null, /*#__PURE__*/React.createElement(DialogContent, {
    ref: ref,
    $size: size
  }, /*#__PURE__*/React.createElement(Collapse, {
    disabled: expanded,
    onRequestChange: onChange,
    isShowing: expanded
  }, /*#__PURE__*/React.createElement(CollapseTrigger, null, /*#__PURE__*/React.createElement(InteractiveTarget, null, header)), /*#__PURE__*/React.createElement(CollapseContent, null, children))));
}
var AnimatedMountContainer = styled(motion.div).attrs({
  transition: {
    duration: 0.3,
    ease: eases.primary
  },
  initial: {
    scale: 0.9,
    height: 0,
    marginBottom: 0,
    opacity: 0
  },
  animate: {
    scale: 1,
    height: 'auto',
    marginBottom: 12,
    opacity: 1
  },
  exit: {
    scale: 0.9,
    height: 0,
    marginBottom: 0,
    opacity: 0
  }
}).withConfig({
  displayName: "AccordionDialogItem__AnimatedMountContainer",
  componentId: "vapor__sc-1p8z8v9-0"
})(["overflow:hidden;"]);
var DialogContent = styled.div.withConfig({
  displayName: "AccordionDialogItem__DialogContent",
  componentId: "vapor__sc-1p8z8v9-1"
})(["", ";"], baseDialogStyles);
var HeaderContainer = styled.div.withConfig({
  displayName: "AccordionDialogItem__HeaderContainer",
  componentId: "vapor__sc-1p8z8v9-2"
})(["display:flex;align-items:center;padding:", ";"], theme.spaces[16]);
var AnimatedCallToAction = styled(motion.div).withConfig({
  displayName: "AccordionDialogItem__AnimatedCallToAction",
  componentId: "vapor__sc-1p8z8v9-3"
})(["margin-left:auto;"]);
var InteractiveTarget = styled.button.withConfig({
  displayName: "AccordionDialogItem__InteractiveTarget",
  componentId: "vapor__sc-1p8z8v9-4"
})(["", ";outline:none;display:block;width:100%;border-radius:", ";&:not([aria-disabled]){cursor:pointer;}", "{box-shadow:", ";}"], buttonReset, theme.radii[6], whenFocused, theme.shadows.interactive.focus);